module.exports = __webpack_public_path__ + "img/4-8subpackage.bb25e666.png";